import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import NotFound from 'Components/NotFound';
import { decryptUserToken } from 'Helpers/';
import { ModuleActions } from 'Constants/Modules.constants';

const PrivateRoute = ({ component: Component, profile, name , ...rest }) => {
  const allowedModule = profile && profile[ name ];
  return (
		<Route
			{ ...rest }
			render={ props =>
				decryptUserToken() ? (
					(allowedModule && allowedModule[ ModuleActions.view ]) || name === '' ? (
						<Component { ...props } />
					) : (
						<NotFound />
					)
				) : (
					<Redirect to={ { pathname: '/login', state: { from: props.location } } } />
				)
			}
		/>
	); };

function mapStatetoProps(state){
  const { profile } = state
  return {
      profile:profile.permission && JSON.parse(profile.permission),
  }
}

export default connect(mapStatetoProps)(PrivateRoute);